import { useEffect, useState } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Eye, Download } from 'lucide-react';
import { cpdAPI, errMsg, download } from '../../lib/cpdRegisterAPI';
import { formatAUDate } from '../../lib/dateUtils';
import { EvidenceCell } from './CPDActivitiesTab';
import { toast } from 'sonner';

const FILTERS = ['', 'Present', 'Missing', 'Incomplete'];

export const CPDEvidenceTab = ({ onOpen, showStaff }) => {
  const [rows, setRows] = useState([]);
  const [ev, setEv] = useState('');
  useEffect(() => { cpdAPI.evidence({ evidence: ev || undefined }).then((r) => setRows(r.items)).catch((e) => toast.error(errMsg(e))); }, [ev]);
  const open = async (r, inline) => {
    try { const b = await cpdAPI.blob(r.evidence_id, inline); if (inline) window.open(URL.createObjectURL(b), '_blank'); else download(b, r.filename); }
    catch (e) { toast.error(errMsg(e, 'Could not open file')); }
  };
  return (
    <div className="space-y-3" data-testid="cpd-evidence-tab">
      <div className="flex gap-1">{FILTERS.map((f) => (
        <Button key={f || 'all'} size="sm" variant={ev === f ? 'default' : 'outline'} className="rounded-full" onClick={() => setEv(f)} data-testid={`cpd-evidence-filter-${f || 'all'}`}>{f || 'All'}</Button>))}</div>
      <Card className="overflow-x-auto"><Table>
        <TableHeader><TableRow>{showStaff && <TableHead>Staff</TableHead>}<TableHead>Activity</TableHead><TableHead>Provider</TableHead><TableHead>Date</TableHead>
          <TableHead>Hours</TableHead><TableHead>Document</TableHead><TableHead>Uploaded</TableHead><TableHead>Status</TableHead><TableHead /></TableRow></TableHeader>
        <TableBody>
          {rows.length === 0 && <TableRow><TableCell colSpan={9} className="text-center text-muted-foreground py-8">Nothing here.</TableCell></TableRow>}
          {rows.map((r, i) => (
            <TableRow key={`${r.activity_id}-${r.evidence_id || i}`} data-testid={`cpd-evidence-row-${r.evidence_id || r.activity_id}`}>
              {showStaff && <TableCell>{r.user_name}</TableCell>}
              <TableCell className="font-medium cursor-pointer hover:underline" onClick={() => onOpen(r.activity_id)}>{r.activity}</TableCell>
              <TableCell>{r.provider}</TableCell><TableCell>{formatAUDate(r.date)}</TableCell><TableCell>{r.hours}</TableCell>
              <TableCell className="text-xs">{r.filename ? `${r.filename} (${r.doc_category})` : '—'}</TableCell>
              <TableCell className="text-xs">{r.uploaded_at ? formatAUDate(r.uploaded_at) : '—'}</TableCell>
              <TableCell><EvidenceCell s={r.evidence_status} /></TableCell>
              <TableCell className="whitespace-nowrap">{r.evidence_id && <>
                <Button size="icon" variant="ghost" onClick={() => open(r, true)} data-testid={`cpd-lib-preview-${r.evidence_id}`}><Eye className="w-4 h-4" /></Button>
                <Button size="icon" variant="ghost" onClick={() => open(r, false)} data-testid={`cpd-lib-download-${r.evidence_id}`}><Download className="w-4 h-4" /></Button></>}</TableCell>
            </TableRow>))}
        </TableBody></Table></Card>
    </div>
  );
};
